<div class="flex flex-col h-full rounded-lg overflow-hidden">
  <!-- Header with Title and Close -->
  <div class="flex justify-between items-center p-4">
    <h3 class="text-lg font-semibold m-0">Receiver: {{ receiverName }}</h3>
    <p-button [rounded]="true" [text]="true" icon="pi pi-times" (onClick)="close()"/>
  </div>

  <!-- Preview Container -->
  <div class="flex-1 flex justify-center items-center p-4 pt-0">
    <div #previewerFrameWrapper class="flex flex-col justify-center h-full w-full">
      <div #previewerFrame class="relative h-full w-full">
        <div class="absolute -z-1 -top-1.5 -left-1.5 h-[calc(100%+theme(space.3))] w-[calc(100%+theme(space.3))] bg-gradient-to-br from-gray-950 to-gray-500 rounded-xl"></div>
        <div class="h-full w-full rounded-lg overflow-hidden bg-gradient-to-br from-gray-900 to-gray-700">
          <div class="contents" [ngClass]="{'hidden': (receiverViewMode$ | async) !== eReceiverViewMode.PREVIEW}">
            <ng-container #previewContainer></ng-container>
          </div>
          <div class="contents" [ngClass]="{'hidden': (receiverViewMode$ | async) !== eReceiverViewMode.LIVE_VIEW}">
            <ng-container #liveViewContainer></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer with Toggle -->
  <div class="flex justify-start items-center p-4">
    <zaeper-toggle-button [buttons]="toggleButtons" (onChange)="switchViewMode($event)"/>
  </div>
</div>
